import { DataTypeEnum } from "../../enums/DataTypeEnum";
import { AggregateType, ColumnType, DateRangeType, EventColumnEnum, OptionalColumnEnum, TatColumnFormulaType, TimeframeType } from "../../enums/DRCXEnums";
import { NumericalFunctionEnum } from "../../enums/NumericalFunctionEnum";
import { makeColumnEquatableKey } from "../../utilities/drcx/MakeColumnEquatableKey";
import { IEquatable } from "../IEquatable";
import { IDRCXConfigurationSectionColumnDTO } from "./DRCXConfigurationSectionColumnDTO";

export class DRCXConfigurationSectionColumnModel implements IEquatable<string> {
    public columnType: ColumnType | undefined = undefined;

    public name: string | undefined = undefined;
    public label: string | undefined = undefined;
    public nameFormat: string | undefined = undefined;
    public order: number = 0;
    public netFormat: string | undefined = undefined;
    public excelFormat: string | undefined = undefined;
    public isHidden: boolean = false;
    public makeRowProperty: boolean = false;

    // columnType == ColumnType.Tat || columnType == ColumnType.MetaData
    public tagAssociationTypeID: number | undefined = undefined;

    // columnType == ColumnType.TatType || columnType == ColumnType.MetaData
    public tatTypeID: number | undefined = undefined;

    // columnType == ColumnType.Tat || columnType == ColumnType.TatType || columnType == ColumnType.MetaData
    public groupingTimeframe: TimeframeType | undefined = undefined;
    public groupingFunction: NumericalFunctionEnum | undefined = undefined;
    public processInDB: boolean = true;

    // columnType == ColumnType.MetaData
    // public metaDataType: MetaDataType | undefined = undefined;
    // public startOffset: number | undefined = undefined;
    // public startRangeType: DateRangeType | undefined = undefined;
    // public duration: number | undefined = undefined;
    // public durationRangeType: DateRangeType | undefined = undefined;

    // columnType == ColumnType.Tat || columnType == ColumnType.TatType
    public summaryFunction: NumericalFunctionEnum | undefined = undefined;
    public useListText: boolean = true;
    public decimalPlaces: number | undefined = undefined;

    public isUomHidden: boolean = false;
    public isAggregationHidden: boolean = false;

    public aggregationType: AggregateType | undefined = AggregateType.None;
    public aggregationPeriod: number | undefined = 0;
    public aggregationFunction: NumericalFunctionEnum | undefined = NumericalFunctionEnum.None;

    public aggregationStepDateRange: DateRangeType | undefined = undefined;
    public aggregationStep: number | undefined = undefined;
    public tatColumnFormulaType: TatColumnFormulaType | undefined = undefined;
    public tatColumnFormulaExpressionText: string | undefined = undefined;

    // columnType == ColumnType.Optional
    public optionalColumn: OptionalColumnEnum | undefined = undefined;
    public key: string | undefined = undefined;
    public eventColumn: EventColumnEnum | undefined = undefined;

    // Extra
    public isDefault: boolean = false;
    public isRequired: boolean = false;
    public dataType: DataTypeEnum | undefined = undefined;

    public id: number | undefined = undefined;
    public objectName: string | undefined = undefined;


    public recentMemoDurationDays: number | undefined = undefined;

    


    // UI only
    //public isNew: boolean = false;

    public constructor(dto?: IDRCXConfigurationSectionColumnDTO) {
        if (dto) {
            if (typeof dto.columnType !== "undefined") {
                this.columnType = dto.columnType;
            }
            if (typeof dto.name !== "undefined") {
                this.name = dto.name
                    ? dto.name.trim()
                    : undefined;
            }
            if (typeof dto.label !== "undefined") {
                this.label = dto.label
                    ? dto.label.trim()
                    : undefined;
            }
            if (typeof dto.nameFormat !== "undefined") {
                this.nameFormat = dto.nameFormat
                    ? dto.nameFormat.trim()
                    : undefined;
            }
            if (typeof dto.order !== "undefined") {
                this.order = dto.order;
            }
            if (typeof dto.netFormat !== "undefined") {
                this.netFormat = dto.netFormat;
            }
            if (typeof dto.excelFormat !== "undefined") {
                this.excelFormat = dto.excelFormat;
            }
            if (typeof dto.isHidden !== "undefined") {
                this.isHidden = dto.isHidden;
            }

            if (typeof dto.isAggregationHidden !== "undefined") {
                this.isAggregationHidden = dto.isAggregationHidden;
            }


            if (typeof dto.makeRowProperty !== "undefined") {
                this.makeRowProperty = dto.makeRowProperty;
            }
            if (typeof dto.tagAssociationTypeID !== "undefined") {
                this.tagAssociationTypeID = dto.tagAssociationTypeID;
            }
            if (typeof dto.tatTypeID !== "undefined") {
                this.tatTypeID = dto.tatTypeID;
            }
            if (typeof dto.groupingTimeframe !== "undefined") {
                this.groupingTimeframe = dto.groupingTimeframe;
            }
            if (typeof dto.groupingFunction !== "undefined") {
                this.groupingFunction = dto.groupingFunction;
            }
            if (typeof dto.processInDB !== "undefined") {
                this.processInDB = dto.processInDB;
            }
            // if (typeof dto.metaDataType !== "undefined") {
            //     this.metaDataType = dto.metaDataType;
            // }
            // if (typeof dto.startOffset !== "undefined") {
            //     this.startOffset = dto.startOffset;
            // }
            // if (typeof dto.startRangeType !== "undefined") {
            //     this.startRangeType = dto.startRangeType;
            // }
            // if (typeof dto.duration !== "undefined") {
            //     this.duration = dto.duration;
            // }
            // if (typeof dto.durationRangeType !== "undefined") {
            //     this.durationRangeType = dto.durationRangeType;
            // }
            if (typeof dto.summaryFunction !== "undefined") {
                this.summaryFunction = dto.summaryFunction;
            }
            if (typeof dto.useListText !== "undefined") {
                this.useListText = dto.useListText;
            }
            if (typeof dto.decimalPlaces !== "undefined") {
                this.decimalPlaces = dto.decimalPlaces;
            }
            if (typeof dto.aggregationType !== "undefined") {
                this.aggregationType = dto.aggregationType;
            }
            if (typeof dto.aggregationPeriod !== "undefined") {
                this.aggregationPeriod = dto.aggregationPeriod;
            }
            if (typeof dto.aggregationFunction !== "undefined") {
                this.aggregationFunction = dto.aggregationFunction;
            }
            if (typeof dto.aggregationStepDateRange !== "undefined") {
                this.aggregationStepDateRange = dto.aggregationStepDateRange;
            }
            if (typeof dto.aggregationStep !== "undefined") {
                this.aggregationStep = dto.aggregationStep;
            }
            if (typeof dto.tatColumnFormulaType !== "undefined") {
                this.tatColumnFormulaType = dto.tatColumnFormulaType;
            }
            if (typeof dto.tatColumnFormulaExpressionText !== "undefined") {
                this.tatColumnFormulaExpressionText = dto.tatColumnFormulaExpressionText;
            }
            if (typeof dto.optionalColumn !== "undefined") {
                this.optionalColumn = dto.optionalColumn;
            }
            if (typeof dto.key !== "undefined") {
                this.key = dto.key;
            }
            if (typeof dto.isDefault !== "undefined") {
                this.isDefault = dto.isDefault;
            }
            if (typeof dto.isRequired !== "undefined") {
                this.isRequired = dto.isRequired;
            }
            if (typeof dto.eventColumn !== "undefined") {
                this.eventColumn = dto.eventColumn;
            }
            if (typeof dto.dataType !== "undefined") {
                this.dataType = dto.dataType;
            }

            if (typeof dto.isUomHidden !== "undefined") {
                this.isUomHidden = dto.isUomHidden;
            }

            if (typeof dto.objectName !== 'undefined') {
                this.objectName = dto.objectName;
            }

            if (typeof dto.recentMemoDurationDays !== 'undefined') {
                this.recentMemoDurationDays = dto.recentMemoDurationDays;
            }


            if (typeof dto.id !== 'undefined') {
                this.id = dto.id;
            } else if (this.optionalColumn === OptionalColumnEnum.DeviceAttributeSchema ||
                this.optionalColumn === OptionalColumnEnum.WellAttributeSchema ||
                this.optionalColumn === OptionalColumnEnum.TankAttributeSchema ||
                this.optionalColumn === OptionalColumnEnum.TagAttributeSchema) {

                if (this.key !== undefined && this.id === undefined) {
                    this.id = +this.key;
                    this.key = this.name;
                }
            }

        }
    }

    // IEquatable Implementation
    public get equatableKey(): string {
        return makeColumnEquatableKey(
            this.columnType,
            this.optionalColumn,
            this.key,
            this.tagAssociationTypeID,
            this.tatTypeID,
            this.dataType,
            this.groupingTimeframe,
            this.groupingFunction,
            this.aggregationType,
            this.aggregationPeriod,
            this.aggregationFunction,
            this.aggregationStepDateRange,
            this.aggregationStep,
            this.eventColumn,
            this.id            
        );

        // return this.columnType === ColumnType.Optional
        //     ? makeOptionalColumnEquatableKey(
        //         this.optionalColumn as OptionalColumnEnum,
        //         this.key as string)
        //     : this.columnType === ColumnType.Tat
        //         ? makeTatColumnEquatableKey(
        //             this.tagAssociationTypeID as number,
        //             this.dataType ?? DataTypeEnum.Double,
        //             this.groupingTimeframe as TimeframeType,
        //             this.groupingFunction,
        //             this.aggregationType,
        //             this.aggregationPeriod,
        //             this.aggregationFunction,
        //             this.aggregationStepDateRange,
        //             this.aggregationStep)
        //         : this.columnType === ColumnType.TatType
        //             ? makeTatTypeColumnEquatableKey(
        //                 this.tatTypeID as number,
        //                 this.dataType ?? DataTypeEnum.Double,
        //                 this.groupingTimeframe as TimeframeType,
        //                 this.groupingFunction,
        //                 this.aggregationType,
        //                 this.aggregationPeriod,
        //                 this.aggregationFunction,
        //                 this.aggregationStepDateRange,
        //                 this.aggregationStep)
        //             : makeEventColumnEquatableKey(this.eventColumn as EventColumnEnum);
        
        // // : this.columnType === ColumnType.Event
        // //     ? makeEventColumnEquatableKey(this.eventColumn as EventColumnEnum)
        // //don't need this                        
        // // : makeMetaDataColumnEquatableKey(
        // //     this.tagAssociationTypeID as number,
        // //     this.groupingTimeframe as TimeframeType,
        // //     this.groupingFunction as NumericalFunctionEnum,
        // //     this.metaDataType as MetaDataType,
        // //     this.startOffset as number,
        // //     this.startRangeType as DateRangeType,
        // //     this.duration as number,
        // //     this.durationRangeType as DateRangeType);
    }

    // public set equatableKey(value: string) {
    //     const components: string[] = value.split(":");
    //     this.columnType = components.length > 0 && components[0].length > 0 ? Number(components[0]) : undefined;

    //     if (this.columnType === ColumnType.Optional) {

    //         this.optionalColumn = components.length > 1 && components[1].length > 0 ? Number(components[1]) as OptionalColumnEnum : undefined;
    //         this.key = components.length > 2 && components[2].length > 0 ? components[2] : undefined;

    //     } else if (this.columnType === ColumnType.Tat) {

    //         this.tagAssociationTypeID = components.length > 1 && components[1].length > 0 ? Number(components[1]) : undefined;
    //         this.groupingTimeframe = components.length > 2 && components[2].length > 0 ? Number(components[2]) : undefined;
    //         this.groupingFunction = components.length > 3 && components[3].length > 0 ? Number(components[3]) : undefined;
    //         this.aggregationType = components.length > 4 && components[4].length > 0 ? Number(components[4]) as AggregateType : undefined;
    //         this.aggregationPeriod = components.length > 5 && components[5].length > 0 ? Number(components[5]) : undefined;
    //         this.aggregationFunction = components.length > 6 && components[6].length > 0 ? Number(components[6]) as NumericalFunctionEnum : undefined;
    //         this.aggregationStepDateRange = components.length > 7 && components[7].length > 0 ? Number(components[7]) as DateRangeType : undefined;
    //         this.aggregationStep = components.length > 8 && components[8].length > 0 ? Number(components[8]) : undefined;

    //     } else if (this.columnType === ColumnType.TatType) {

    //         this.tatTypeID = components.length > 1 && components[1].length > 0 ? Number(components[1]) : undefined;
    //         this.groupingTimeframe = components.length > 2 && components[2].length > 0 ? Number(components[2]) : undefined;
    //         this.groupingFunction = components.length > 3 && components[3].length > 0 ? Number(components[3]) : undefined;
    //         this.aggregationType = components.length > 4 && components[4].length > 0 ? Number(components[4]) as AggregateType : undefined;
    //         this.aggregationPeriod = components.length > 5 && components[5].length > 0 ? Number(components[5]) : undefined;
    //         this.aggregationFunction = components.length > 6 && components[6].length > 0 ? Number(components[6]) as NumericalFunctionEnum : undefined;
    //         this.aggregationStepDateRange = components.length > 7 && components[7].length > 0 ? Number(components[7]) as DateRangeType : undefined;
    //         this.aggregationStep = components.length > 8 && components[8].length > 0 ? Number(components[8]) : undefined;

    //     } else { // this.columnType === ColumnType.MetaData

    //         this.tagAssociationTypeID = components.length > 1 && components[1].length > 0 ? Number(components[1]) : undefined;
    //         this.groupingTimeframe = components.length > 2 && components[2].length > 0 ? Number(components[2]) : undefined;
    //         this.groupingFunction = components.length > 3 && components[3].length > 0 ? Number(components[3]) : undefined;
    //         this.metaDataType = components.length > 4 && components[4].length > 0 ? Number(components[4]) : undefined;
    //         this.startOffset = components.length > 5 && components[5].length > 0 ? Number(components[5]) : undefined;
    //         this.startRangeType = components.length > 6 && components[6].length > 0 ? Number(components[6]) : undefined;
    //         this.duration = components.length > 7 && components[7].length > 0 ? Number(components[7]) : undefined;
    //         this.durationRangeType = components.length > 8 && components[8].length > 0 ? Number(components[8]) : undefined;

    //     }
    // }

    public toDTO(): IDRCXConfigurationSectionColumnDTO {
        return {
            columnType: this.columnType,
            name: this.name,
            label: this.label,
            nameFormat: this.nameFormat,
            order: this.order,
            netFormat: this.netFormat,
            excelFormat: this.excelFormat,
            isHidden: this.isHidden,
            makeRowProperty: this.makeRowProperty,
            tagAssociationTypeID: this.tagAssociationTypeID,
            tatTypeID: this.tatTypeID,
            groupingTimeframe: this.groupingTimeframe,
            groupingFunction: this.groupingFunction,
            processInDB: this.processInDB,
            // metaDataType: this.metaDataType,
            // startOffset: this.startOffset,
            // startRangeType: this.startRangeType,
            // duration: this.duration,
            // durationRangeType: this.durationRangeType,
            summaryFunction: this.summaryFunction,
            useListText: this.useListText,
            decimalPlaces: this.decimalPlaces,
            aggregationType: this.aggregationType,
            aggregationPeriod: this.aggregationPeriod,
            aggregationFunction: this.aggregationFunction,
            aggregationStepDateRange: this.aggregationStepDateRange,
            aggregationStep: this.aggregationStep,
            tatColumnFormulaType: this.tatColumnFormulaType,
            tatColumnFormulaExpressionText: this.tatColumnFormulaExpressionText,
            optionalColumn: this.optionalColumn,
            key: this.key,
            isDefault: this.isDefault,
            isRequired: this.isRequired,
            eventColumn: this.eventColumn,
            dataType: this.dataType,
            isUomHidden: this.isUomHidden,
            isAggregationHidden: this.isAggregationHidden,
            id: this.id,
            objectName: this.objectName,
            recentMemoDurationDays: this.recentMemoDurationDays
        };
    }

    // public static makeOptionalEquatableKey(
    //     optionalColumn: OptionalColumnEnum,
    //     key: string): string {
    //     return [
    //         ColumnType.Optional,
    //         typeof optionalColumn === "number" ? optionalColumn : "",
    //         typeof key === "string" ? key : "",
    //     ].join(":");
    // }

    // public static makeEventEquatableKey(
    //     eventColumn: EventColumnEnum): string {
    //     return [
    //         ColumnType.Event,
    //         typeof eventColumn === "number" ? eventColumn : ""
    //     ].join(":");
    // }

    // public static parseEventColumnFromEquatableKey(equatableKey: string): EventColumnEnum {
    //     const parts = equatableKey.split(":");
    //     return Number(parts[1]) as EventColumnEnum;
    // }

    // public static makeTatEquatableKey(
    //     tatID: number,
    //     groupingTimeframe: TimeframeType,
    //     groupingFunction?: NumericalFunctionEnum,
    //     aggregationType?: AggregateType,
    //     aggregationPeriod?: number,
    //     aggregationFunction?: number,
    //     aggregationStepDateRange?: DateRangeType,
    //     aggregationStep?: number): string {
    //     return groupingTimeframe === TimeframeType.Hourly ||
    //         groupingTimeframe === TimeframeType.Daily ||
    //         groupingTimeframe === TimeframeType.Weekly ||
    //         groupingTimeframe === TimeframeType.Monthly ||
    //         groupingTimeframe === TimeframeType.Yearly
    //         ? [
    //             ColumnType.Tat,
    //             typeof tatID === "number" ? tatID : "",
    //             typeof groupingTimeframe === "number" ? groupingTimeframe : "",
    //             typeof groupingFunction === "number" ? groupingFunction : "0",
    //             typeof aggregationType === "number" ? aggregationType : "0",
    //             typeof aggregationPeriod === "number" ? aggregationPeriod : "0",
    //             typeof aggregationFunction === "number" ? aggregationFunction : "0",
    //             typeof aggregationStepDateRange === "number" ? aggregationStepDateRange : "",
    //             typeof aggregationStep === "number" ? aggregationStep : ""
    //         ].join(":")
    //         : [
    //             ColumnType.Tat,
    //             typeof tatID === "number" ? tatID : "",
    //             typeof groupingTimeframe === "number" ? groupingTimeframe : ""
    //         ].join(":");
    // }

    // public static makeTatTypeEquatableKey(
    //     tatTypeID: number,
    //     groupingTimeframe: TimeframeType,
    //     groupingFunction?: NumericalFunctionEnum,
    //     aggregationType?: AggregateType,
    //     aggregationPeriod?: number,
    //     aggregationFunction?: number,
    //     aggregationStepDateRange?: DateRangeType,
    //     aggregationStep?: number): string {
    //     return groupingTimeframe === TimeframeType.Hourly ||
    //         groupingTimeframe === TimeframeType.Daily ||
    //         groupingTimeframe === TimeframeType.Weekly ||
    //         groupingTimeframe === TimeframeType.Monthly ||
    //         groupingTimeframe === TimeframeType.Yearly
    //         ? [
    //             ColumnType.TatType,
    //             typeof tatTypeID === "number" ? tatTypeID : "",
    //             typeof groupingTimeframe === "number" ? groupingTimeframe : "",
    //             typeof groupingFunction === "number" ? groupingFunction : "0",
    //             typeof aggregationType === "number" ? aggregationType : "0",
    //             typeof aggregationPeriod === "number" ? aggregationPeriod : "0",
    //             typeof aggregationFunction === "number" ? aggregationFunction : "0",
    //             typeof aggregationStepDateRange === "number" ? aggregationStepDateRange : "",
    //             typeof aggregationStep === "number" ? aggregationStep : ""
    //         ].join(":")
    //         : [
    //             ColumnType.TatType,
    //             typeof tatTypeID === "number" ? tatTypeID : "",
    //             typeof groupingTimeframe === "number" ? groupingTimeframe : ""
    //         ].join(":");
    // }

    // // Not supported in reporting
    // public static makeMetaDataEquatableKey(
    //     tatID: number,
    //     groupingTimeframe: TimeframeType,
    //     groupingFunction: NumericalFunctionEnum,
    //     metaDataType: MetaDataType,
    //     startOffset: number,
    //     startRangeType: DateRangeType,
    //     duration: number,
    //     durationRangeType: DateRangeType): string {
    //     return [
    //         ColumnType.MetaData,
    //         typeof tatID === "number" ? tatID : "",
    //         typeof groupingTimeframe === "number" ? groupingTimeframe : "",
    //         typeof groupingFunction === "number" ? groupingFunction : "",
    //         typeof metaDataType === "number" ? metaDataType : "",
    //         typeof startOffset === "number" ? startOffset : "",
    //         typeof startRangeType === "number" ? startRangeType : "",
    //         typeof duration === "number" ? duration : "",
    //         typeof durationRangeType === "number" ? durationRangeType : ""
    //     ].join(":");
    // }
}
